import React from 'react';

const GlassCard = ({ children, className = '', hover = true }) => {
  return (
    <div className={`bg-white border border-border shadow-md rounded-[5px] p-8 ${hover ? '' : 'hover:translate-y-0 hover:bg-white/45'} ${className}`}>
      {children}
    </div>
  );
};

export default GlassCard;
